import us from 'uScope/js/defines';
import { keyCodes } from 'uScope/js/lib/key-codes';
import { triggerUScopeEvent } from '../../_uScope';
import app from '../../public-api';

app.plugins.register({
  name: 'us:hmi:keyboard',
  extends: 'viewport',
  init (uScope, viewport) {
    viewport.events.on('viewport:bind-events', (namespace) => {
      const $divViewport = viewport.vpDivGet('outer');
      // In IE, jQuery will fire keydown(), not keypress() for the arrow keys, because they are considered 'special' keys.
      // Note that focus must be on the viewport.  Sometimes Tab must be hit if you think these keys aren't working.
      $divViewport.on('keydown' + namespace + ' keyup' + namespace, handleKeyboardEvent);

      function handleKeyboardEvent (e) {
        // processing keyup and keydown would cause double actions; only handle keydown
        if (e.type !== 'keydown') {
          return;
        }

        // Track if we've handled the event so we can intelligently prevent event propagation.
        var eventIsHandled = true;

        // Note that key events on special keys like control are not reported as e.ctrlKey
        // so I use 'which' to normalizes keycodes between browsers.
        // Note: jQuery normalizes the property name to 'which', but not the value of the property, which can vary between browsers for some keys
        // http://stackoverflow.com/questions/18177818/why-jquerys-event-which-gives-different-results-in-firefox-and-chrome
        var keyCode = e.which;
        var keyText = e.key;

        const overlapHigh = 0.25; // proportion of view width or height to move
        const overlapLow = 0.75; // proportion of view width or height to move
        let dx;
        let dy;
        let rotXY;

        switch (keyCode) {
          // spacebar is used for rasterScan
          case keyCodes.spacebar:
            triggerUScopeEvent(us.evSPACEBAR, {});
            break;

          // ............................................ panning
          // .......... xy position moves
          case keyCodes.arrowUp:
          case keyCodes.arrowDown:
            dx = 0;
            dy = (e.shiftKey) ? viewport.getViewHeight() * overlapLow : viewport.getViewHeight() * overlapHigh;
            dy = dy / viewport.getViewZoom();

            if (e.keyCode == keyCodes.arrowUp) dy = -dy;

            rotXY = us.coordUnRotToRot(dx, dy, viewport);
            viewport.moveRelative(rotXY.x, rotXY.y);
            break;
          case keyCodes.arrowLeft:
          case keyCodes.arrowRight:
            dy = 0;
            dx = (e.shiftKey) ? viewport.getViewWidth() * overlapLow : viewport.getViewWidth() * overlapHigh;
            dx = dx / viewport.getViewZoom();
            if (e.keyCode == keyCodes.arrowLeft) {
              dx = -dx;
            }

            rotXY = us.coordUnRotToRot(dx, dy, viewport);
            viewport.moveRelative(rotXY.x, rotXY.y); // xf - just for consistency,
            break;
          // ............................................ zooming
          case keyCodes.minus: // zoom out
          case keyCodes.numMinus:
          case keyCodes.FF_minus:
          case keyCodes.lang.fr.minus:
            if (e.ctrlKey && keyText === '-') {
              viewport.zoomStep(us.zoomSpecs.stepFactor);
            }
            break;
          case keyCodes.plus: // zoom in shows more detail so a 10x could become 20x
          case keyCodes.numPlus:
          case keyCodes.FF_plus:
            if (e.ctrlKey && keyText === '+') {
              viewport.zoomStep(-us.zoomSpecs.stepFactor);
            }
            break;
          // ............................................ rotation
          case keyCodes.num0: // set rotation to 0
          case keyCodes.zero:
            if (us.ENABLEROTATION == true) {
              viewport.viewRotate(0, {animate: true});
            }
            break;
          case keyCodes.r: // no shift key => step 1 degrees, shift key => step 15 degree; control key => rotate ccw
            if (us.ENABLEROTATION == true) {
              let angleDeg = viewport.getViewAngle(true);
              if (e.shiftKey && e.ctrlKey) angleDeg -= 1;
              else if (e.shiftKey) angleDeg += 1;
              else if (e.ctrlKey) angleDeg -= 15;
              else angleDeg += 15;

              viewport.viewRotate(angleDeg, {animate: true});
            }
            break;
          // ............................................ next/prev slide
          case keyCodes.e: //
            triggerUScopeEvent(us.evOPENNEXTSLIDE, {});
            break;
          case keyCodes.q: //
            triggerUScopeEvent(us.evOPENPREVSLIDE, {});
            break;
          // ............................................
          case keyCodes.t:
            break;
          default:
            eventIsHandled = false;
        }

        // this disables scrolling while moving around on the self
        if (eventIsHandled) {
          e.preventDefault();
        } else {
          viewport.events.trigger('viewport:keyup', keyCode, e);
        }
      }
    });
  }
});
